

import React, { useState, useEffect, useRef } from 'react'
import { Input, Menu, Grid, Form, Button } from 'semantic-ui-react'
import LocationTab from "../../../components/LocationTab/LocationTab"
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash'
import GuestsTab from '../../../components/GuestsTab/GuestsTab'
import SearchLocation from '../../../components/SearchLocation/SearchLocation'
import { SetStartDate, SetEndDate } from "../../../../../redux/actions/mainActions"
import bgimg from "../../../../../assets/images/bg-stripped.jpeg"
import { useTranslation } from 'react-i18next';
import "./SearchResidence.css"



function useOutsideAlerter(ref, setActiveItem, calendarOpen = false) {
  useEffect(() => {
    function handleClickOutside(event) {

      if(calendarOpen== true){
        console.log("closed")

        ref.current.closeCalendar()

      }
       else if (ref.current && !ref.current.contains(event.target)) {
        console.log("closed2")

        setActiveItem("")
      }
      

    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}




const SearchResidence = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [activeItem, setActiveItem] = useState('')
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setActiveItem);
  const lang = useSelector((state) => state.main.lang)

  const startDate = useSelector((state) => state.main.startDate)
  const endDate = useSelector((state) => state.main.endDate)
  const guestsList = useSelector((state) => state.main.guestsList)
  const searchArea = useSelector((state) => state.main.searchArea)
  const [showLocationTab, setShowLocationTab] = useState(true)

  const calendarRef = useRef(null);


  // useOutsideAlerter(calendarRef,setActiveItem,true)


  const handleItemClick = (name) => {
    setActiveItem(name)
  }

  useEffect(()=>{
    if(activeItem !== "checkin" && activeItem !== "checkout"){
      calendarRef.current.closeCalendar()
    }
  },[activeItem])

  const renderDatePicker = () => {
  return lang === "fa-IR" ? 
        <DatePicker
      ref={calendarRef}
      render={(value, openCalendar) => {
        return (
          <Input onClick={openCalendar} value={endDate} placeholder={t("home:CheckoutSelect")} readOnly className=" price-input" />
          )
      }}
      mapDays={({ date }) => {
        var today = new Date()
        
        if (date < today) return {
          disabled: true,
          style: {  backgroundImage: `url(${bgimg})`,     backgroundSize: "contain"},
        }
      }}
      range
      calendarPosition="bottom-left"
      className="calendar-class"
      numberOfMonths={2}
      calendar={persian}
      locale={persian_fa}
      hideOnScroll={true}
      onChange={(date) => {
        dispatch(SetStartDate(new Date(date[0]).toLocaleDateString('fa-IR')))
        if(new Date(date[1]).toLocaleDateString('fa-IR') != "Invalid Date"){
          dispatch(SetEndDate(new Date(date[1]).toLocaleDateString('fa-IR')))
        }
      }}
      value={startDate}
    />
   : <DatePicker
      ref={calendarRef}
      render={(value, openCalendar) => {
        return (
          <Input onClick={openCalendar} value={endDate} placeholder={t("home:CheckoutSelect")} readOnly className=" price-input" />
          )
      }}
      mapDays={({ date }) => {
        var today = new Date()
        
        if (date < today) return {
          disabled: true,
          style: {  backgroundImage: `url(${bgimg})`,     backgroundSize: "contain"},

        }
      }}
      range
      calendarPosition="bottom-right"
      className="calendar-class"
      numberOfMonths={2}
      hideOnScroll={true}
      onChange={(date) => {
        dispatch(SetStartDate(new Date(date[0])))
        if(new Date(date[1]) != "Invalid Date"){
          dispatch(SetEndDate(new Date(date[1])))

        }
      }}
      value={startDate}
    />
    
  }
  return <div ref={wrapperRef}>
    <Grid textAlign="right" centered columns="equal" className="search-residence m-1 bg-white rounded-50 text-black">
      <Grid.Row className="p-0 bg-f3 rounded-50">
        <Grid.Column verticalAlign="middle" onClick={() => {
          handleItemClick('search-location')
      
      }} className={`p-05 tabular-col ${activeItem === 'search-location' ? "tabular-col-active" : "tabular-col-notactive"}`}>
          <Menu.Item
            className="search-item"
            name={t("home:Location")}
            active={activeItem === 'search-location'}
          />
          <SearchLocation activeItem={activeItem} setActiveItem={setActiveItem} />
        </Grid.Column>
        <Grid.Column id="checkin-date" verticalAlign="middle" onClick={() => {
          handleItemClick('checkin')
          calendarRef.current.openCalendar()
          

        }} className={`p-05 tabular-col ${activeItem === 'checkin' ? "tabular-col-active" : "tabular-col-notactive"}`}>
          <Menu.Item
            className="search-item"
            name={t("home:Checkin")}
            active={activeItem === 'checkin'}
          />
                <Input onClick={()=>calendarRef.current.openCalendar()} value={startDate} placeholder={t("home:CheckinSelect")}  readOnly className=" price-input" />

       
        </Grid.Column>
        <Grid.Column verticalAlign="middle" onClick={() =>{ 
          handleItemClick('checkout')
          calendarRef.current.openCalendar()

          }} className={`p-05 tabular-col ${activeItem === 'checkout' ? "tabular-col-active" : "tabular-col-notactive"}`}>
          <Menu.Item
            className="search-item"
            name={t("home:Checkout")}
            active={activeItem === 'checkout'}

          />
         
         {renderDatePicker()}

        </Grid.Column>
        <Grid.Column verticalAlign="middle" onClick={() => handleItemClick('guests')} className={`p-05 tabular-col ${activeItem === 'guests' ? "tabular-col-active" : "tabular-col-notactive"}`}>
          <Menu.Item
            className="search-item"
            name={t("home:Guests")}
            active={activeItem === 'guests'}
          />

          <Input value={guestsList} readOnly placeholder={t("home:GuestsSelect")} className="w-100 price-input" />
          {
            activeItem === 'guests' ?  <Grid centered verticalAlign="middle" className="position-absolute z-index-2200 bg-white w-100 rounded-30 top-110" >
            <Grid.Column width={16}><GuestsTab /></Grid.Column></Grid>  : null
          }


        </Grid.Column>
        <Grid.Column width="1" verticalAlign="middle" className="p-0 text-center">

          <Button circular size='tiny' icon="search" color="red" >
          </Button>
        </Grid.Column>


      </Grid.Row>
    </Grid>
  </div>
}

export default SearchResidence